// extracted by mini-css-extract-plugin
export var chevron = "_36-d";
export var disabled = "_36-b";
export var error = "_36-c";
export var hideBorder = "_36-1";
export var icon = "_36-e";
export var input = "_36-0";
export var large = "_36-f";
export var open = "_36-9";
export var placeholder = "_36-a";
export var regular = "_36-5";
export var singleRowInput = "_36-2";
export var singleSelectInput = "_36-3 _36-0";
export var small = "_36-4";
export var spinnerContainer = "_36-i";
export var tag = "_36-7";
export var tagsContainer = "_36-8";
export var tagsInput = "_36-6 _36-0";
export var xSmall = "_36-g";
export var xxSmall = "_36-h";